import { render, staticRenderFns } from "./DoctorRegisterHospitalModal.vue?vue&type=template&id=7b538d9d&"
import script from "./DoctorRegisterHospitalModal.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterHospitalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports